import { Divider, Drawer, List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  navBarHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function NavigationBar()
{
  const classes = useStyles();
  const history = useHistory();

  return (
    <Drawer
      variant="permanent"
      classes={{ paper: classes.drawerPaper }}
    >
      <div className={classes.navBarHeader}>
      </div>
      <Divider />
      <List>

        <ListItem button onClick={() => history.push('/Cube')}>
          <ListItemText primary="Cubes" />
        </ListItem>

        <ListItem button onClick={() => history.push('/Group')}>
          <ListItemText primary="Groups" />
        </ListItem>

        <ListItem button onClick={() => history.push('/GamePoints')}>
          <ListItemText primary="Game Points" />
        </ListItem>

        <ListItem button onClick={() => history.push('/Operators')}>
          <ListItemText primary="Operators" />
        </ListItem>

        <ListItem button onClick={() => history.push('/Leaderboard')}>
          <ListItemText primary="Leaderboard" />
        </ListItem>

        <ListItem button onClick={() => history.push('/TrafficShaping')}>
          <ListItemText primary="Traffic Shaping" />
        </ListItem>

        <ListItem button onClick={() => history.push('/LiveView')}>
          <ListItemText primary="Live View" />
        </ListItem>
        
      </List>
    </Drawer>
  );
}